// Exchange amounts and prices are integers in minimal units (4 decimals) — no floating point on
// the way to the signature. These helpers convert between the user's text and those units.

export const DECIMALS = 4;
const SCALE = 10n ** BigInt(DECIMALS);

// "12.5" -> 125000n; null when the text is not a non-negative number with at most 4 decimals
export function toUnits(text) {
  if (text === null || text === undefined) return null;
  const s = String(text).trim().replace(',', '.');
  if (!/^\d*(\.\d*)?$/.test(s) || s === '' || s === '.') return null;
  const [int, frac = ''] = s.split('.');
  if (frac.length > DECIMALS) return null;
  return BigInt(int || '0') * SCALE + BigInt((frac + '0000').slice(0, DECIMALS));
}

export function big(v) {
  if (typeof v === 'bigint') return v;
  if (v === null || v === undefined || v === '') return 0n;
  return BigInt(v);
}

// 125000n -> "12.5"; fixed: always that many decimals (cut, not rounded)
export function fromUnits(v, fixed) {
  const n = big(v);
  const neg = n < 0n;
  const a = neg ? -n : n;
  const int = a / SCALE;
  let frac = (a % SCALE).toString().padStart(DECIMALS, '0');
  if (fixed !== undefined) {
    frac = frac.slice(0, fixed);
  } else {
    frac = frac.replace(/0+$/, '');
  }
  const intStr = int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return (neg ? '-' : '') + intStr + (frac ? '.' + frac : '');
}

// decimals implied by a step: 100 (0.01) -> 2, 1 (0.0001) -> 4, 10000 (1) -> 0
export function stepDecimals(step) {
  let s = big(step);
  let d = DECIMALS;
  while (d > 0 && s % 10n === 0n) {
    s /= 10n;
    d -= 1;
  }
  return d;
}

export function quoteOf(amount, price) {
  return (big(amount) * big(price)) / SCALE;
}

// fee rounded up like the contract
export function feeOf(quote, bps) {
  const q = big(quote);
  if (!bps || q === 0n) return 0n;
  return (q * BigInt(bps) + 9999n) / 10000n;
}

export function roundDownTo(v, step) {
  const s = big(step);
  return (big(v) / s) * s;
}

export function roundUpTo(v, step) {
  const s = big(step);
  return ((big(v) + s - 1n) / s) * s;
}

export function minBig(a, b) {
  return big(a) < big(b) ? big(a) : big(b);
}

// percent change between two unit values, as a number for display only
export function pctChange(from, to) {
  const f = big(from);
  if (f === 0n) return null;
  return Number(((big(to) - f) * 1000000n) / f) / 10000;
}
